module.exports = __webpack_public_path__ + "static/media/white_red1.2715a085.jpg";